import VerifyEmailComponent from "@forwardflow/components/Onboarding/VerifyEmail";

const VerifyEmail = () => {
  return (
    <>
      <VerifyEmailComponent />
    </>
  );
};

export default VerifyEmail;
